export enum FormErrorKey {
  REQUIRED = 'required',
  MAX_LENGTH = 'maxlength',
  EXISTED = 'existed',
}
